import { MAX_CHARACTER_INPUT_VALIDATION, MAX_CHARACTER_ORGANIZATION_ID_VALIDATION } from "@/constants/common";
import { INVALID_PASSWORD_CONFIRM } from "@/constants/invalids";
import { validator } from "@/utils/validator";

export const resetPasswordSchema = validator.object().shape({
  ownerId: validator.string().trim().emptyToNull().max(MAX_CHARACTER_ORGANIZATION_ID_VALIDATION).label("組織ID").required(),
  newPassword: validator.string().trim().emptyToNull().strongPassword().max(MAX_CHARACTER_INPUT_VALIDATION).label("新しいパスワード").required(),
  confirmNewPassword: validator
    .string()
    .trim()
    .when("newPassword", {
      is: (newPassword: string) => newPassword && newPassword.length > 0,
      then: (schema) => schema.oneOf([validator.ref("newPassword")], INVALID_PASSWORD_CONFIRM),
      otherwise: (schema) => schema.required(),
    })
    .max(MAX_CHARACTER_INPUT_VALIDATION)
    .label("新しいパスワード（確認用）"),
});
